"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexToColor = void 0;
const colorFormatter_1 = require("../../shared/functionality/colorFormatter/colorFormatter");
const color_convert_1 = __importDefault(require("color-convert"));
class HexToColor {
    static convertToRgb(color, options) {
        const result = color_convert_1.default.hex.rgb(color);
        return (options === null || options === void 0 ? void 0 : options.resultType) === 'string' ? colorFormatter_1.ColorFormatter.arrayToRgbString(result) : result;
    }
    static convertToHsl(color, options) {
        const result = color_convert_1.default.hex.hsl(color);
        return (options === null || options === void 0 ? void 0 : options.resultType) === 'string' ? colorFormatter_1.ColorFormatter.arrayToHslString(result) : result;
    }
}
exports.HexToColor = HexToColor;
